<template>
  <el-tooltip :content="content || $t('generic.edit')" :placement="placement" :open-delay="300" width="250">
    <template v-if="$attrs.to">
      <router-link :to="$attrs.to" class="btn btn-sm btn-icon btn-outline-secondary">
        <i v-if="!$attrs.loading" :class="icon"></i>
      </router-link>
    </template>
    <template v-else>
      <base-button outline
                   icon
                   size="sm"
                   v-bind="$attrs"
                   v-on="$listeners">
        <slot>
          <i v-if="!$attrs.loading" :class="icon"></i>
        </slot>
      </base-button>
    </template>
  </el-tooltip>
</template>
<script>
  export default {
    name: 'tooltip-icon-button',
    inheritAttrs: false,
    props: {
      content: String,
      placement: {
        type: String,
        default: 'top'
      },
      openDelay: {
        type: Number,
        default: 300
      },
      icon: String
    }
  }
</script>
<style>
</style>
